import * as Yup from "yup";
import { forceInt } from "Utils";
import { transform as userTransformer } from "./User";
import { transform as assignmentTransformer } from "./Assignment";

export const AssignmentCommentValidationSchema = Yup.object().shape({});

export const AssignmentCommentObjectSchema = {
    id: null,
    uuid: null,
    srn: null,
    assignment_id: null,
    user_id: null,
    comment: null,
    created_at: null,
    user: {},
    assignment: {},
};

/**
 * Transform API object to a AssignmentComment object
 * @param {object} requestData JSON object from the API
 * @returns Object
 */
export function transform(requestData) {
    if (requestData.data) {
        return requestData.data.map((item) => transform(item));
    }

    let comment = Object.assign({}, AssignmentCommentObjectSchema, {
        id: forceInt(requestData.id),
        uuid: requestData.uuid,
        srn: requestData.srn,
        comment: requestData.comment,
        assignment_id: requestData.assignment_id,
        user_id: requestData.user_id,
        created_at: requestData.created_at,
        object_type: "assignmentComment",
    });

    if (requestData.user) {
        let user = userTransformer(requestData.user);
        comment = Object.assign({}, comment, { user: user });
    }
    if (requestData.assignment) {
        let assignment = assignmentTransformer(requestData.assignment);
        comment = Object.assign({}, comment, { assignment: assignment });
    }

    return comment;
}

/**
 * Serialize the content object to a string
 * @param {object} item
 * @returns string
 */
export function serialize(item) {
    return JSON.stringify(item);
}

/**
 * Deserialize json string
 * @param {string} item
 * @returns object
 */
export function deserialize(item) {
    return JSON.parse(item);
}

/**
 *
 * @param {object} item The object being saved
 * @param {object} resetVars Values to overwrite after preparation
 * @returns Object
 */
export function prepare(item, resetVars = {}) {
    return Object.assign(
        {},
        item,
        {
            object_type: undefined,
        },
        resetVars
    );
}
